module.exports = __webpack_public_path__ + "img/55_72.7633a4bf.png";